import { gql } from '@apollo/client'

export const GET_SIGNED_URL = gql`
  query GetSignedUrl {
    getSignedUrl
  }
`

export const GET_AUTOSCHEDULER_ONBOARDING_SIGNED_URL = gql`
  query GetAutoschedulerOnboardingSignedUrl {
    getAutoschedulerOnboardingSignedUrl
  }
`

export const GET_OWN_WORDS_SIGNED_URL = gql`
  query GetOwnWordsSignedUrl($draft: String!) {
    getOwnWordsSignedUrl(draft: $draft)
  }
`

export const GET_AUTOSCHEDULER_XAI_VOICE_SESSION = gql`
  query GetAutoschedulerXaiVoiceSession {
    getAutoschedulerXaiVoiceSession {
      token
      expiresAt
      websocketUrl
      model
    }
  }
`

export const INITIATE_VOICE_CALL = gql`
  mutation InitiateVoiceCall($prompt: String) {
    initiateVoiceCall(prompt: $prompt)
  }
`

export const GET_INCOMING_CALL_NUMBER = gql`
  query GetIncomingCallNumber {
    getIncomingCallNumber
  }
`

export const GET_CALL_RECORDS = gql`
  query GetCallRecords($limit: Int, $offset: Int) {
    getCallRecords(limit: $limit, offset: $offset) {
      id
      userId
      conversationId
      durationSeconds
      minutesCharged
      elevenLabsCost
      timestamp
      createdAt
    }
  }
`

export const GET_DEMO_CALL_SIGNED_URL = gql`
  query GetDemoCallSignedUrl($agentId: String, $sessionId: String) {
    getDemoCallSignedUrl(agentId: $agentId, sessionId: $sessionId)
  }
`

export const DEMO_EVENTS_SUBSCRIPTION = gql`
  subscription DemoEvents($sessionId: String!) {
    demoEvents(sessionId: $sessionId) {
      id
      type
      sessionId
      title
      description
      content
      url
      metadata
      timestamp
    }
  }
`

export const END_DEMO_CALL = gql`
  mutation EndDemoCall($sessionId: String!) {
    endDemoCall(sessionId: $sessionId)
  }
`

export const GET_DEMO_MINUTES_STATUS = gql`
  query GetDemoMinutesStatus {
    getDemoMinutesStatus {
      minutesUsed
      minutesRemaining
      totalMinutesAllowed
    }
  }
`

export const USER_EVENTS_SUBSCRIPTION = gql`
  subscription UserEvents {
    userEvents {
      id
      type
      userId
      sessionId
      title
      description
      content
      url
      metadata
      timestamp
    }
  }
`
